module.exports = __webpack_public_path__ + "static/img/xitong1.abb036cd.webp";